import List from "@material-ui/core/esm/List";
import ListItem from "@material-ui/core/esm/ListItem";
import ListItemText from "@material-ui/core/esm/ListItemText";
import Receipt from "@material-ui/icons/esm/Receipt";
import Home from "@material-ui/icons/esm/Home";
import DirectionsCar from "@material-ui/icons/esm/DirectionsCar";
import LockOpen from "@material-ui/icons/esm/LockOpen";
import RssFeed from "@material-ui/icons/esm/RssFeed";
import React from 'react';
import { useTranslation } from 'react-i18next';
import { NavLink } from 'react-router-dom';
import { ACCESS_MANAGEMENT_PATH } from 'routes/AccessManagement/paths';
import { HOME } from 'routes/home/paths';
import { INVOICES } from 'routes/invoices/paths';
import { AGREEMENTS } from 'routes/overview/paths';
import { PASSINGS_PATH } from 'routes/passings/paths';
import useStyles from '../NavigationStyles';
export default function NavigationDrawerList() {
  const {
    list,
    icon,
    drawerNavLinkActive
  } = useStyles();
  const {
    t
  } = useTranslation();
  return /*#__PURE__*/React.createElement(List, {
    className: list
  }, /*#__PURE__*/React.createElement(ListItem, {
    button: true,
    key: "Home",
    component: NavLink,
    exact: true,
    to: HOME,
    activeClassName: drawerNavLinkActive
  }, /*#__PURE__*/React.createElement(Home, {
    className: icon
  }), /*#__PURE__*/React.createElement(ListItemText, {
    primary: t('titles.home')
  })), /*#__PURE__*/React.createElement(ListItem, {
    button: true,
    key: "Agreement",
    component: NavLink,
    exact: true,
    to: AGREEMENTS,
    activeClassName: drawerNavLinkActive
  }, /*#__PURE__*/React.createElement(DirectionsCar, {
    className: icon
  }), /*#__PURE__*/React.createElement(ListItemText, {
    primary: t('titles.agreements')
  })), /*#__PURE__*/React.createElement(ListItem, {
    button: true,
    key: "Invoices",
    component: NavLink,
    to: INVOICES,
    activeClassName: drawerNavLinkActive
  }, /*#__PURE__*/React.createElement(Receipt, {
    className: icon
  }), /*#__PURE__*/React.createElement(ListItemText, {
    primary: t('titles.invoices')
  })), /*#__PURE__*/React.createElement(ListItem, {
    button: true,
    key: "Passings",
    component: NavLink,
    to: PASSINGS_PATH,
    activeClassName: drawerNavLinkActive
  }, /*#__PURE__*/React.createElement(RssFeed, {
    className: icon
  }), /*#__PURE__*/React.createElement(ListItemText, {
    primary: t('titles.passings')
  })), /*#__PURE__*/React.createElement(ListItem, {
    button: true,
    key: "Access management",
    component: NavLink,
    to: ACCESS_MANAGEMENT_PATH,
    activeClassName: drawerNavLinkActive
  }, /*#__PURE__*/React.createElement(LockOpen, {
    className: icon
  }), /*#__PURE__*/React.createElement(ListItemText, {
    primary: t('titles.access_management')
  })));
}